import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import { DumbAutoSetting } from "../../models/KeySelectionOptions.model";
import OptionMenuOneLineToggle from "../theme_reuse/OptionMenuOneLineToggle";

interface Props {}
interface State {}

const shortNames = [DumbAutoSetting.Manual, DumbAutoSetting.Auto];

function printShortName(x: DumbAutoSetting): string {
  switch (x) {
    case DumbAutoSetting.Manual:
      return "Do not automate";
    case DumbAutoSetting.Auto:
      return "Auto-silence 1/2 step above root";
  }
}

export default class AutoIgnore2Toggle extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  changeSetting = (dim2ndIgnore: DumbAutoSetting) => {
    const oldOptions = this.context.keySelectionOptions;
    this.context.dispatch({
      type: "EditKeySelectionOptions",
      payload: { ...oldOptions, autoPin: { ...oldOptions.autoPin, dim2ndIgnore } },
    });
  };

  render(): ReactNode {
    const selected = this.context.keySelectionOptions.autoPin.dim2ndIgnore;
    return (
      <OptionMenuOneLineToggle
        selected={selected}
        printShortName={printShortName}
        onChange={this.changeSetting}
        optionShortNames={shortNames}
      />
    );
  }
}

AutoIgnore2Toggle.contextType = AppContextType;
